import BaseExtension from './base';

import { createElement, removeClass, addClass } from '../utils';

import createSvg, { PAUSE, PLAY, REPLAY } from '../svgs';

import popover from './helpers/popover';

const CN = 'rmp-ext-play';
const PLAYING_CN = `${CN}--playing`;
const PAUSED_CN = `${CN}--paused`;
const ENDED_CN = `${CN}--ended`;

export default class PlayExtension extends BaseExtension {
   constructor(player, state, options) {
      super(player, state, options, ['pause', 'play', 'ended', 'seeking']);
      this.logger.debug('play:extension:creating');

      this.render();
      this.addEvent(this.$el, 'click', this.toggle.bind(this));

      this.logger.debug('play:extension:created');
   }

   render() {
      /** @type {HTMLMediaElement} */
      this.$el = createElement('button', { type: 'button', class: `${CN} ${PAUSED_CN}` });

      setTimeout(() => {
         const text = () => {
            if (this.player.isEnded()) {
               return this.$t('replay');
            } else if (this.player.isPaused()) {
               return this.$t('play');
            }
            return this.$t('pause');
         };
         popover(this, { $button: this.$el, text });
      });

      createSvg(this.$el, PLAY, {class: 'play'});
      createSvg(this.$el, PAUSE, {class: 'pause'});
      createSvg(this.$el, REPLAY, {class: 'replay'});
   }

   toggle() {
      if (this.player.isPaused() || this.player.isEnded()) {
         this.player.play();
      } else {
         this.player.pause();
      }
   }

   onPause() {
      this.$el.setAttribute('aria-label', 'Play');
      removeClass(this.$el, PLAYING_CN);
      removeClass(this.$el, ENDED_CN);
      addClass(this.$el, PAUSED_CN);
   }

   onPlay() {
      this.$el.setAttribute('aria-label', 'Pause');
      removeClass(this.$el, PAUSED_CN);
      removeClass(this.$el, ENDED_CN);
      addClass(this.$el, PLAYING_CN);
   }

   onEnded() {
      if (this.options.playLoop) {
         this.player.play();
      } else {
         this.$el.setAttribute('aria-label', 'Reply');
         removeClass(this.$el, PAUSED_CN);
         removeClass(this.$el, PLAYING_CN);
         addClass(this.$el, ENDED_CN);
      }
   }

   onSeeking() {
      removeClass(this.$el, ENDED_CN);
      removeClass(this.$el, PAUSED_CN);
      removeClass(this.$el, PLAYING_CN);

      if (this.player.isPaused()) {
         addClass(this.$el, PAUSED_CN);
      } else {
         addClass(this.$el, PLAYING_CN);
      }
   }

   getElement() {
      return this.$el;
   }

   destroy() {
      super.destroy();

      const parent = this.$el.parentNode;
      parent.removeChild(this.$el);
      this.$el = null;
   }
}
